import { useFormik } from 'formik';
import useTranslate from 'hooks/useTranslate';
import { ReactNode } from 'react';
import { Col, Form, Row } from 'react-bootstrap';
import * as Yup from 'yup';
import ActionMenu from '../ActionMenu';
import { TEXTAREA_TEXT_LIMIT } from 'constants';

interface ShortBioInterface {
	shortBio: string;
}

const ShortBio = ({
	data,
	slug,
	handleRemoveClick,
	onHandleChange,
	handleTitleChange,
	stateResumeForm,
}: any) => {
	const { translate } = useTranslate();
	const validationSchema = Yup.object().shape({
		shortBio: Yup.string()
			.min(
				50,
				translate('Validation.min', { field: translate('PlaceHolder.shortBio'), number: '50' }),
			)
			.max(
				TEXTAREA_TEXT_LIMIT,
				translate('Validation.max', {
					field: translate('PlaceHolder.shortBio'),
					number: `${TEXTAREA_TEXT_LIMIT}`,
				}),
			)
			.required(translate('Validation.required', { field: translate('PlaceHolder.shortBio') })),
	});

	const formik = useFormik({
		initialValues: {
			shortBio: data,
		},
		enableReinitialize: true,
		validationSchema: validationSchema,
		onSubmit: () => {},
	});

	const renderError = <T extends keyof ShortBioInterface>(field: T) =>
		formik.touched[field] && formik.errors[field] ? (
			<span className="text-danger f-error">{formik.errors[field] as ReactNode}</span>
		) : null;

	const handleAddSuggestion = (content: any) => {
		const eventObj = {
			target: {
				name: 'shortBio',
				value: content,
			},
		};
		onHandleChange(slug, eventObj);
		formik.setFieldValue('shortBio', content);
	};

	return (
		<div className="resume-info">
			<Form onSubmit={formik.handleSubmit} autoComplete="off">
				<div className="build-resume-edit-header">
					<ActionMenu
						data={data}
						handleRemoveClick={handleRemoveClick}
						slug="shortBioTitle"
						contentSlug={slug}
						handleTitleChange={handleTitleChange}
					/>
					<p className="mb-0">{translate('Resume.shortBioCharacters')}</p>
				</div>
				<div className="build-resume-edit-fields">
					<Row>
						<Col xl="12">
							<div className="text-start">
								<Form.Group className="mb-4 position-relative">
									<Form.Label className="lh-1">{translate('PlaceHolder.shortBio')}</Form.Label>
									<Form.Control
										onChange={(event: any) => {
											onHandleChange(slug, event);
											formik.setFieldValue('shortBio', event.target.value);
										}}
										name="shortBio"
										as="textarea"
										maxLength={TEXTAREA_TEXT_LIMIT}
										placeholder="Enter here"
										style={{ minHeight: '156px' }}
										value={formik.values.shortBio}
										onBlur={formik.handleBlur}
									/>

									<div className="alert-msg">{renderError('shortBio')}</div>

									<div className="position-absolute end-0" style={{ bottom: '-20px' }}>
										<p className="text-end mb-0">
											{formik.values.shortBio?.length}/{TEXTAREA_TEXT_LIMIT}
										</p>
									</div>
								</Form.Group>
							</div>
						</Col>
					</Row>
				</div>
			</Form>
		</div>
	);
};

export default ShortBio;
